module.exports = __webpack_public_path__ + "static/media/loading.a7f6f906.gif";